// extracted by mini-css-extract-plugin
export default {"toast":"Toast_toast__XYm57","toast__text":"Toast_toast__text__gex6M","toast__close-btn":"Toast_toast__close-btn__5lxIZ"};